const CURRENT_TENANT_UUID_STORAGE_KEY = 'currentTenantUuid';
const CURRENT_TENANT_UUID_CHANGED_EVENT = 'current-tenant-uuid-changed';

export const saveCurrentTenantUuid = (tenantUuid?: string | null) => {
  try {
    if (tenantUuid) {
      localStorage.setItem(CURRENT_TENANT_UUID_STORAGE_KEY, tenantUuid);
    } else {
      localStorage.removeItem(CURRENT_TENANT_UUID_STORAGE_KEY);
    }
  } catch {
    // ignore storage access errors
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(CURRENT_TENANT_UUID_CHANGED_EVENT));
  }
};

export const readCurrentTenantUuid = () => {
  try {
    return localStorage.getItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const subscribeCurrentTenantUuidChange = (listener: () => void) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  window.addEventListener(CURRENT_TENANT_UUID_CHANGED_EVENT, listener);
  return () => {
    window.removeEventListener(CURRENT_TENANT_UUID_CHANGED_EVENT, listener);
  };
};
